import { render, staticRenderFns } from "./dashboard-all.vue?vue&type=template&id=65689425"
import script from "./dashboard-all.vue?vue&type=script&lang=js"
export * from "./dashboard-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports